/* EBH — selector de país + idioma.
   Carregado pelo snippet 'ebh-locale-panel'. Pode entrar duas vezes na página
   (cabeçalho e rodapé); a guarda abaixo garante que só se liga uma vez.
   Os países chegam a pedido (sections/ebh-country-list.liquid) — ver
   loadCountryTemplates. */
(function () {
  'use strict';
  if (window.__ebhLocalePanel) return;
  window.__ebhLocalePanel = true;

  var FALLBACK_LOCALES = ['en'];

  function parseLocaleMap(raw) {
    var map = {};
    (raw || '').split(';').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length !== 2 || !bits[0]) return;
      map[bits[0]] = bits[1].split('|').filter(Boolean);
    });
    return map;
  }

  /* Procurar a sequência em qualquer parte do nome enchia a lista de ruído:
     «re» apanhava Grécia, Barém, Comores, Coreia do Sul. Passou a bater só
     no INÍCIO de uma palavra — «re» dá Reino Unido, República…, Reunião. */
  function comecaPor(nome, q) {
    if (!q) return true;
    if (nome.indexOf(q) === 0) return true;
    var partes = nome.split(/[\s(),.'\u2019\/-]+/);
    for (var i = 0; i < partes.length; i++) {
      if (partes[i] && partes[i].indexOf(q) === 0) return true;
    }
    return false;
  }

  function strip(value) {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }


  /* ---- países a pedido ----
     Desde 2026-09-06 a página já não traz os 237 países (eram escritos três
     vezes: cabeçalho, rodapé e menu mobile — ~700 KB de HTML). Vêm de
     sections/ebh-country-list.liquid pela Section Rendering API, uma única
     vez por página, na primeira vez que alguém abre um selector. O pedido
     usa a raiz localizada (/en-pt/, /) para o país marcado sair certo. */
  var countryTemplates = null;

  function localizedRoot(hint) {
    var base = hint || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base;
  }

  function loadCountryTemplates(rootHint) {
    if (countryTemplates) return countryTemplates;
    var url = localizedRoot(rootHint) + '?section_id=ebh-country-list';
    countryTemplates = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('ebh-country-list ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var out = {};
        doc.querySelectorAll('template[data-ebh-country-list]').forEach(function (tpl) {
          out[tpl.getAttribute('data-ebh-country-list')] = tpl;
        });
        if (!out.own || !out.other || !out.drawer) throw new Error('ebh-country-list sem templates');
        return out;
      })
      .catch(function (err) {
        countryTemplates = null; /* deixar tentar outra vez no próximo clique */
        if (window.console) console.warn('[ebh-locale-panel]', err);
        throw err;
      });
    return countryTemplates;
  }

  function fillFromTemplate(target, tpl) {
    target.appendChild(document.importNode(tpl.content, true));
  }


  /* ---- modo dropdown: só idiomas (cabeçalho) ----
     Cada língua é um <button type="submit" name="locale_code">, logo aplica-se
     sozinha ao clicar. O JS aqui só abre e fecha, e esconde as línguas que o
     mercado do visitante não serve. */
  function setupMenu(root) {
    var trigger = root.querySelector('[data-ebh-loc-open]');
    var menu = root.querySelector('[data-ebh-loc-menu]');
    if (!trigger || !menu) return;

    var localeMap = parseLocaleMap(root.dataset.ebhLocaleMap);
    var country = root.dataset.ebhLocCurrentCountry || '';
    var allowed = localeMap[country] && localeMap[country].length ? localeMap[country].slice() : FALLBACK_LOCALES.slice();
    var here = root.dataset.ebhLocCurrentLocale;
    if (here && allowed.indexOf(here) === -1) allowed.push(here);

    root.querySelectorAll('[data-ebh-loc-menu-row]').forEach(function (row) {
      var btn = row.querySelector('[data-ebh-loc-locale]');
      row.hidden = !btn || allowed.indexOf(btn.dataset.ebhLocLocale) === -1;
    });

    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    menu.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) {
        close();
        trigger.focus({ preventScroll: true });
      }
    });

    close();
  }

  function setup(root) {
    if (root.querySelector('[data-ebh-loc-menu]')) return setupMenu(root);

    var form = root.closest('form');
    var trigger = root.querySelector('[data-ebh-loc-open]');
    var sheet = root.querySelector('.ebh-loc__sheet');
    var scrim = root.querySelector('.ebh-loc__scrim');
    if (!form || !trigger || !sheet) return;

    var localeMap = parseLocaleMap(root.dataset.ebhLocaleMap);
    var search = root.querySelector('[data-ebh-loc-search]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-group]'));
    var countries = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-country]'));
    var lazyLists = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-lazy]'));
    var loaded = lazyLists.length === 0; /* marcação antiga já traz tudo */
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-locale]'));
    var empty = root.querySelector('[data-ebh-loc-empty]');
    var more = root.querySelector('[data-ebh-loc-more]');
    var showOther = false;
    var note = root.querySelector('[data-ebh-loc-note]');
    var card = root.querySelector('[data-ebh-loc-card]');
    /* EBH 2026-09-17 — loja americana — ver snippets/ebh-locale-panel.liquid */
    var usBox = root.querySelector('[data-ebh-loc-us]');
    var saveBtn = root.querySelector('[data-ebh-loc-save]');
    var saveLabel = saveBtn ? saveBtn.textContent.trim() : '';
    var countryInput = root.querySelector('[data-ebh-loc-country-input]');

    /* Quem paga as taxas, por mercado — snippets/ebh-duties-map.liquid, uma
       decisão declarada e não um campo da API. Ver a lição sobre a Suíça. */
    var dutiesPairs = {};
    /* EBH 2026-09-17 — taxas por modo: o valor é o MODO (1/0/2/3), não sim/não. */
    var dutiesRest = '0';
    if (card && card.dataset.ebhLocDuties) {
      var partes = card.dataset.ebhLocDuties.split('|');
      partes[0].split(';').forEach(function (par) {
        var kv = par.split(':');
        if (kv.length === 2) dutiesPairs[kv[0]] = kv[1];
      });
      dutiesRest = partes[1] || '0';
    }
    var localeInput = root.querySelector('[data-ebh-loc-locale-input]');

    /* O cabeçalho mostra só a língua, logo não tem input de país. Ainda assim
       precisa de saber onde o visitante está — senão um belga via apenas inglês,
       porque allowedLocales(null) cai no fallback. */
    var committed = {
      country: countryInput ? countryInput.value : root.dataset.ebhLocCurrentCountry || null,
      locale: localeInput ? localeInput.value : null
    };
    var draft = { country: committed.country, locale: committed.locale };
    var lastFocus = null;

    /* O mapa é gerado da Admin API e pode ficar velho quando se mexe nos
       Mercados. O idioma em que a página está a ser servida entra sempre na
       lista — assim um mapa desactualizado esconde opções, nunca a actual. */
    function allowedLocales(code) {
      var list = localeMap[code];
      var out = list && list.length ? list.slice() : FALLBACK_LOCALES.slice();
      var here = root.dataset.ebhLocCurrentLocale;
      if (here && out.indexOf(here) === -1) out.push(here);
      return out;
    }

    function paint() {
      /* Um visitante pode estar em /pt com o país da sessão na Islândia, cujo
         mercado só serve inglês. Nesse caso nenhum chip ficaria marcado — logo
         normalizamos o idioma ao que o mercado escolhido serve de facto. */
      var allowedNow = allowedLocales(draft.country);
      if (allowedNow.indexOf(draft.locale) === -1) draft.locale = allowedNow[0];

      countries.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.ebhLocCountry === draft.country ? 'true' : 'false');
      });

      chips.forEach(function (chip) {
        var ok = allowedNow.indexOf(chip.dataset.ebhLocLocale) > -1;
        chip.hidden = !ok;
        chip.setAttribute('aria-pressed', ok && chip.dataset.ebhLocLocale === draft.locale ? 'true' : 'false');
      });

      var picked = countries.filter(function (b) { return b.dataset.ebhLocCountry === draft.country; })[0];
      var money = picked ? picked.dataset.ebhLocMoney : '';
      var name = picked ? picked.querySelector('.ebh-loc__name').textContent : '';

      if (note) note.textContent = money ? name + ' — ' + money : '';

      if (card) {
        if (!picked) {
          card.hidden = true;
        } else {
          var modo = dutiesPairs.hasOwnProperty(draft.country) ? dutiesPairs[draft.country] : dutiesRest;
          var d = card.dataset;
          var taxas = {
            '1': [d.ebhLocDutiesIn, d.ebhLocDutiesInSub],
            '2': [d.ebhLocDutiesCheckout, d.ebhLocDutiesCheckoutSub],
            '3': [d.ebhLocDutiesIn, d.ebhLocDutiesIslandsSub]
          }[modo] || [d.ebhLocDutiesOut, d.ebhLocDutiesOutSub];
          card.querySelector('[data-ebh-loc-card-money]').textContent = money;
          /* EUA/Canadá: o imposto não vai no preço — a linha do IVA mentia. */
          var iva = card.querySelector('[data-ebh-loc-card-tax]');
          if (iva) iva.style.display = modo === '0' || modo === '2' ? 'none' : '';
          card.querySelector('[data-ebh-loc-card-duties]').textContent = taxas[0];
          card.querySelector('[data-ebh-loc-card-duties-sub]').textContent = taxas[1];
          var linhaTaxas = card.querySelector('[data-ebh-loc-card-duties-row]');
          linhaTaxas.classList.toggle('is-warn', modo === '0' || modo === '2');
          linhaTaxas.classList.toggle('is-note', modo === '3');
          card.hidden = false;
        }
      }

      /* EUA e Canadá: a ficha dizia «IVA incluído» (falso — o imposto soma-se
         no checkout) e calava a loja americana. Passa a aviso com link. */
      if (usBox) {
        var loja = picked && (draft.country === 'US' || draft.country === 'CA') ? draft.country.toLowerCase() : '';
        usBox.hidden = !loja;
        if (loja) {
          usBox.querySelector('[data-ebh-loc-us-title]').textContent = usBox.getAttribute('data-us-title-' + loja);
          usBox.querySelector('[data-ebh-loc-us-msg]').textContent = usBox.getAttribute('data-us-msg-' + loja);
          var usGo = usBox.querySelector('[data-ebh-loc-us-go]');
          usGo.textContent = usBox.getAttribute('data-us-go-' + loja);
          usGo.href = (window.ebhLojaUSBase || 'https://eggbackhomeusa.com/') +
            '?utm_source=eggbackhome.com&utm_medium=locale-panel&utm_campaign=us-store';
        }
        if (saveBtn) {
          saveBtn.textContent = loja ? usBox.getAttribute('data-us-stay') : saveLabel;
          saveBtn.classList.toggle('ebh-loc__save--quiet', !!loja);
        }
      }
    }

    /* Uma regra por LINHA, não por grupo:
         - lista dos 9: visível se bate na pesquisa, ou se é a escolhida
         - «outros destinos»: só com pesquisa escrita ou com o «Internacional»
           aberto — mas a escolhida fica sempre, mesmo depois de limpar
       Abrir o grupo inteiro porque a escolhida vive lá dentro despejava 228
       países no painel. */
    function filter() {
      var q = strip(search ? search.value : '');
      var shown = 0;

      countries.forEach(function (btn) {
        var group = btn.closest('[data-ebh-loc-group]');
        var searchOnly = group && group.hasAttribute('data-ebh-loc-search-only');
        var escolhido = btn.dataset.ebhLocCountry === draft.country;
        var bate = !q ||
          comecaPor(strip(btn.dataset.ebhLocName), q) ||
          strip(btn.dataset.ebhLocCountry).indexOf(q) === 0;

        var visivel = searchOnly
          ? escolhido || (bate && (!!q || showOther))
          : escolhido || bate;

        btn.parentNode.hidden = !visivel;
        if (visivel) shown++;
      });

      groups.forEach(function (group) {
        group.hidden = group.querySelectorAll('.ebh-loc__item:not([hidden])').length === 0;
      });

      var results = root.querySelector('[data-ebh-loc-results]');
      if (results) results.classList.toggle('is-searching', !!q);

      if (empty) empty.hidden = shown > 0;
      if (more) {
        more.hidden = !!q;
        more.setAttribute('aria-expanded', showOther ? 'true' : 'false');
      }
    }

    /* EBH 2026-09-10 — separadores do telemóvel. O atributo vive na folha e é
       só o CSS (@media 620px) que decide se se vê alguma coisa: no computador
       as duas colunas continuam lado a lado. */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-tab]'));

    function setView(nome) {
      sheet.dataset.ebhLocView = nome;
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.dataset.ebhLocTab === nome ? 'true' : 'false');
      });
      sheet.scrollTop = 0;
      var grid = sheet.querySelector('.ebh-loc__grid');
      if (grid) grid.scrollTop = 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setView(tab.dataset.ebhLocTab); });
    });
    if (tabs.length) setView('country');

    function open() {
      if (tabs.length) setView('country');
      draft.country = committed.country;
      draft.locale = committed.locale;
      if (search) search.value = '';
      showOther = false;
      filter();
      paint();
      if (!loaded) {
        ensureCountries().then(function () {
          if (!sheet.hidden) { filter(); paint(); }
        });
      }
      sheet.hidden = false;
      if (scrim) scrim.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ebh-loc-open');
      lastFocus = document.activeElement;
      var estreito = window.matchMedia('(max-width: 620px)').matches;
      ((estreito ? null : search) || sheet).focus({ preventScroll: true });
    }

    function close() {
      sheet.hidden = true;
      if (scrim) scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ebh-loc-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    trigger.addEventListener('click', function () {
      if (sheet.hidden) open(); else close();
    });

    root.querySelectorAll('[data-ebh-loc-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !sheet.hidden) close();
    });

    function bindCountry(btn) {
      btn.addEventListener('click', function () {
        draft.country = btn.dataset.ebhLocCountry;
        var allowed = allowedLocales(draft.country);
        if (allowed.indexOf(draft.locale) === -1) draft.locale = allowed[0];
        paint();
        filter();
      });
    }
    countries.forEach(bindCountry);

    /* Primeira abertura: pedir a lista, encher os dois grupos, ligar os cliques
       e só então filtrar e pintar. As aberturas seguintes já têm tudo. */
    function ensureCountries() {
      if (loaded) return Promise.resolve();
      var results = root.querySelector('[data-ebh-loc-results]');
      if (results) results.setAttribute('aria-busy', 'true');
      return loadCountryTemplates(root.dataset.ebhLocLazyRoot).then(function (tpls) {
        if (loaded) return;
        lazyLists.forEach(function (list) {
          var key = list.getAttribute('data-ebh-loc-lazy');
          if (tpls[key]) fillFromTemplate(list, tpls[key]);
        });
        countries = Array.prototype.slice.call(root.querySelectorAll('[data-ebh-loc-country]'));
        countries.forEach(bindCountry);
        loaded = true;
      }).then(function () {
        if (results) results.removeAttribute('aria-busy');
      }, function () {
        if (results) results.removeAttribute('aria-busy');
        if (empty) empty.hidden = false;
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        draft.locale = chip.dataset.ebhLocLocale;
        paint();
      });
    });

    if (more) {
      more.addEventListener('click', function () {
        showOther = !showOther;
        filter();
      });
    }

    if (search) search.addEventListener('input', filter);

    form.addEventListener('submit', function () {
      if (countryInput) countryInput.value = draft.country;
      if (localeInput) localeInput.value = draft.locale;
    });

    filter();
    paint();
  }


  /* ---- lista de países do menu mobile ----
     O drawer tem a sua própria marcação (snippets/drawer-menu.liquid).
     Aqui só escondemos os destinos fora dos 33 mercados e deixamos a
     pesquisa trazê-los de volta. */
  function setupDrawer(input) {
    var list = input.closest('.drawer-menu__list--country-selector');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-ebh-drawer-item]'));
    var more = list.querySelector('[data-ebh-drawer-more]');
    var showExtra = false;
    var placeholder = list.querySelector('[data-ebh-drawer-lazy]');
    var loaded = !placeholder;

    /* O theme.min.js liga o clique de cada país ao arrancar (querySelectorAll
       em [data-item]); os que chegam depois não o têm. Reproduz-se aqui o que
       ele faz — escrever o país no input escondido e submeter o formulário. */
    if (placeholder) {
      list.addEventListener('click', function (event) {
        var link = event.target.closest('[data-item="currency"]');
        if (!link || !list.contains(link)) return;
        event.preventDefault();
        var form = list.closest('form');
        var field = form && form.querySelector('[data-currency-input]');
        if (!form || !field) return;
        var codigo = link.getAttribute('data-value');
        /* EBH 2026-09-17 — loja americana: EUA/Canadá perguntam antes de mudar. */
        if (window.ebhLojaUS && window.ebhLojaUS(codigo, function () {
          field.value = codigo;
          form.submit();
        })) return;
        field.value = codigo;
        form.submit();
      });
    }

    function ensureDrawerCountries() {
      if (loaded) return Promise.resolve();
      list.setAttribute('aria-busy', 'true');
      return loadCountryTemplates(list.getAttribute('data-ebh-drawer-lazy-root')).then(function (tpls) {
        if (loaded) return;
        var frag = document.importNode(tpls.drawer.content, true);
        placeholder.parentNode.insertBefore(frag, placeholder);
        placeholder.parentNode.removeChild(placeholder);
        items = Array.prototype.slice.call(list.querySelectorAll('[data-ebh-drawer-item]'));
        loaded = true;
        list.removeAttribute('aria-busy');
        apply();
      }, function () {
        list.removeAttribute('aria-busy');
      });
    }

    /* «Enviar para» no menu: o theme.min.js faz deslizar a sub-lista; nós
       pedimos os países ao mesmo tempo. */
    var trigger = list.parentNode && list.parentNode.querySelector('[data-item="viewCurrency"]');
    if (trigger) trigger.addEventListener('click', function () { ensureDrawerCountries(); });
    if (input) input.addEventListener('focus', function () { ensureDrawerCountries(); });

    function apply() {
      var q = strip(input.value);
      if (more) {
        more.hidden = !!q;
        more.setAttribute('aria-expanded', showExtra ? 'true' : 'false');
      }
      items.forEach(function (item) {
        var extra = item.hasAttribute('data-ebh-drawer-extra');
        if (!q) {
          item.hidden = extra && !showExtra;
          return;
        }
        var hit =
          comecaPor(strip(item.dataset.ebhDrawerName), q) ||
          item.dataset.ebhDrawerCode.indexOf(q) === 0;
        item.hidden = !hit;
      });
    }

    input.addEventListener('input', apply);
    if (more) {
      more.addEventListener('click', function () {
        showExtra = !showExtra;
        apply();
      });
    }
    apply();
  }

  /* ---- menu mobile: o país e o idioma abrem o painel do rodapé ----
     Um só painel em toda a loja, com a ficha do destino e o «Guardar». Ver
     theme_fixes/mobile_2026-09-10/. */
  function setupDrawerHandoff() {
    var sheet = document.getElementById('ebhLocSheet-footer');
    if (!sheet) return; /* sem painel no rodapé, fica o comportamento do tema */
    var root = sheet.closest('[data-ebh-loc]');
    var abrir = root && root.querySelector('[data-ebh-loc-open]');
    if (!abrir) return;

    function fecharMenu() {
      var drawer = document.querySelector('.drawer-menu.active, .drawer-menu.visible');
      if (!drawer) return false;
      var fecho = drawer.querySelector('[data-overlay], .drawer-menu__overlay');
      if (fecho) fecho.click();
      return true;
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.drawer-menu__footer [data-item="viewCurrency"], .drawer-menu__footer [data-item="viewLanguage"]');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
        var vista = link.getAttribute('data-item') === 'viewLanguage' ? 'lang' : 'country';
        var fechou = fecharMenu();
        setTimeout(function () {
          if (sheet.hidden) abrir.click();
          var tab = root.querySelector('[data-ebh-loc-tab="' + vista + '"]');
          if (tab) tab.click();
        }, fechou ? 260 : 0);
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-ebh-loc]').forEach(setup);
    setupDrawerHandoff();
    document.querySelectorAll('[data-ebh-drawer-search]').forEach(setupDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
